import React from 'react'
import { useTranslation } from 'react-i18next'
import AddIcon from '@material-ui/icons/Add'
import { matchPath, useHistory, useLocation } from 'react-router-dom'
import { NavigationTabContentProps } from 'types/NavigationTab'
import { ChatHistory } from 'components/data/ChatHistory/ChatHistory'
import * as Styled from './ChatNavigationSection.styles'

const ChatNavigationSection: React.FC<NavigationTabContentProps> = ({ onNavigate, children }) => {
  const { t } = useTranslation()
  const history = useHistory()
  const { pathname } = useLocation()
  const chatMatch = matchPath<{ chatId: string }>(pathname, { path: '/chat/:chatId', exact: true })

  const handleNewChat = () => {
    history.push('/chat')
    onNavigate()
  }

  return (
    <Styled.Section>
      <Styled.Header>
        {children}
        <Styled.NewChatButton backgroundGradient onClick={handleNewChat} size='small'>
          {t('aiChat.history.newChat')}
          <AddIcon fontSize='small' />
        </Styled.NewChatButton>
      </Styled.Header>
      <ChatHistory chatId={chatMatch?.params.chatId} onNavigate={onNavigate} />
    </Styled.Section>
  )
}

export { ChatNavigationSection }
